module.exports = {
      id: "hamburger_search-usage",
      viewBox: "0 0 35 23",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#hamburger_search",
      toString: function () {
        return this.url;
      }
    }